<template>
    <auth-admin-layout>
        <Head>
            <title>Login</title>
        </Head>

        <div class="auth-form">
            <div class="auth-form--form">
                <form @submit.prevent="submit">
                    <card class="card--minify card--message error" v-if="form.errors.account">
                        <card-content v-html="form.errors.account"></card-content>
                    </card>

                    <h6 class="text-center">Legen Sie ihr neues Passwort fest.</h6>

                    <form-input type="email" id="email" label="Email Adresse" v-model="form.email"
                                placeholder="john@doe.com" :error="form.errors.email" icon="email-mail-checkmark"
                                autocomplete="email" autofocus/>
                    <form-password type="password" id="password" label="Passwort" v-model="form.password"
                                   :error="form.errors.password"/>

                    <input type="hidden" name="token" v-model="form.token" />

                    <div class="form-actions">
                        <form-button type="submit" color="secondary" icon="lock-shield-prote" :disabled="form.processing" :class="{'btn--processing': form.processing}"><translate>Passwort setzen</translate></form-button>
                    </div>
                </form>
            </div>
        </div>

    </auth-admin-layout>
</template>

<script>
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import AuthAdminLayout from '@partfactory/Layouts/AuthAdminLayout';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormPassword from '@partfactory/Shared/Form/FormPassword';
import CardContent from '@partfactory/Shared/Card/CardContent';
import Card from '@partfactory/Shared/Card/Card';

export default {
    name: 'PasswordReset',
    components: {
        Card,
        CardContent,
        FormPassword,
        FormButton,
        AuthAdminLayout,
        FormInput,
    },
    props: [
        'token',
    ],
    setup () {
        const form = useForm({
            email: null,
            password: null,
            token: null,
        });

        return { form };
    },
    created() {
        this.form.token = this?.token;
    },
    methods: {
        submit() {
            this.form
            .transform(data => ({
                ...data,
                remember: this.form.remember ? 'true' : '',
                _token: this.$page.props.csrf_token,
            }))
            .post(this.$$route('password.reset.post'), {
                onFinish: () => this.form.reset('password'),
            });
        }
    }
};
</script>
